// AI 审单相关 TypeScript 类型定义
// 与 saas-gateway AiAuditVO 字段对齐（详见 openspec/changes/add-factory-order-ai-audit/design.md）

// AI 审单主状态
export const AI_AUDIT_STATUS = {
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  FAILED_PERMANENT: 'FAILED_PERMANENT',
} as const

export type AiAuditStatus = typeof AI_AUDIT_STATUS[keyof typeof AI_AUDIT_STATUS]

// AI 审单字段级别
export const AI_AUDIT_LEVEL = {
  CORRECT: 'correct',
  WARNING: 'warning',
  ERROR: 'error',
} as const

export type AiAuditLevel = typeof AI_AUDIT_LEVEL[keyof typeof AI_AUDIT_LEVEL]

// 反馈类型
// 1=AGREE(AI对了) 2=WRONG_JUDGE(AI错了) 3=NOT_AN_ISSUE(这不是问题)
// 语义对比：
//   AGREE        — AI 判得对，确实是错，需要改
//   WRONG_JUDGE  — AI 判错了，实际没问题
//   NOT_AN_ISSUE — AI 事实判断对，但业务上不算错（运费/折扣/口径差异等）
export const FEEDBACK_TYPE = {
  AGREE: 1,
  WRONG_JUDGE: 2,
  NOT_AN_ISSUE: 3,
} as const

export type FeedbackType = 1 | 2 | 3

// 单字段 AI 结果
export interface AiAuditFieldItem {
  field: string
  expected?: string  // 系统值
  actual?: string    // 截图值
  note?: string      // AI 原因
}

// 单条反馈记录
export interface AiAuditFeedback {
  field: string
  originalAiLevel?: number    // 1=warning 2=error
  feedbackType: FeedbackType
  operatorId?: number
  operatorName?: string
  utcCreate?: number
}

// AI 审单 VO - 同一类两场景复用
export interface AiAuditVO {
  // 轻量字段（列表 + 详情 都填）
  status: AiAuditStatus
  reviewed: 0 | 1
  errorCount: number
  warningCount: number
  failedReason?: string
  reviewedBy?: number
  reviewedByName?: string
  reviewedAt?: string

  // 详情字段（仅详情接口填）
  correct?: AiAuditFieldItem[]
  warning?: AiAuditFieldItem[]
  error?: AiAuditFieldItem[]
  feedbacks?: AiAuditFeedback[]
}
